import { useAgent } from '../AgentContext';

/** This agent's own address, for links between its pages. */
export function useAgentAddress(): string {
  return useAgent().base;
}
